<template>
  <div>
    <div class="text-caption text-uppercase font-weight-bold primary--text mb-2">Conformité sans angoisse</div>
    <h2 class="text-h4 font-weight-black mb-12">EGAlim devient un avantage concurrentiel</h2>

    <v-row class="mb-8">
      <v-col cols="12" sm="4">
        <v-icon color="grey darken-3" class="mb-2" x-large>$seedling-fill</v-icon>
        <p class="mt-4 text-center text-sm-left">
          Promouvoir une alimentation saine et respectueuse de l'environnement.
        </p>
      </v-col>

      <v-col cols="12" sm="4">
        <v-icon color="grey darken-3" class="mb-2" x-large>$team-fill</v-icon>
        <p class="mt-4 text-center text-sm-left">
          Réduire les inégalités d'accès à une alimentation durable et de qualité.
        </p>
      </v-col>

      <v-col cols="12" sm="4">
        <v-icon color="grey darken-3" class="mb-2" x-large>$money-euro-box-fill</v-icon>
        <p class="mt-4 text-center text-sm-left">
          Assurer la juste rémunération des agriculteurs du secteur agricole.
        </p>
      </v-col>
    </v-row>

    <!-- 3 points EgalimBlock -->
    <v-row class="mb-6">
      <v-col v-for="p in egalimPoints" :key="p.title" cols="12" sm="4" class="d-flex">
        <div
          class="pa-4"
          style="border-left: 3px solid #e05a2b; background: #fafafa; border-radius: 0 8px 8px 0; flex: 1"
        >
          <div class="mb-1">{{ p.icon }}</div>
          <strong class="d-block text-body-2">{{ p.title }}</strong>
          <span class="text-caption grey--text text--darken-1">{{ p.desc }}</span>
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <DownloadLink
        label="Télécharger le livret de la loi EGAlim concernant la restauration collective"
        href="/static/documents/2208_Mesures-LoiEgalim_BRO_V3.pdf"
        sizeStr="482 ko"
      />
    </v-row>
  </div>
</template>

<script>
import DownloadLink from "@/components/DownloadLink"

export default {
  components: { DownloadLink },
  data() {
    return {
      egalimPoints: [
        {
          icon: "📊",
          title: "Tableaux de bord prêts",
          desc: "Objectifs qualitatifs, quantitatifs et nutritionnels lisibles pour la direction et les élus.",
        },
        {
          icon: "🌐",
          title: "macantine.gouv.fr alimenté",
          desc: "Aide à la télédéclaration dans l'esprit du pacte national anti-gaspillage.",
        },
        {
          icon: "✅",
          title: "Diagnostic SWOT intégré",
          desc: "Positionnez-vous sur les objectifs de la loi et planifiez vos actions d'amélioration.",
        },
      ],
    }
  },
}
</script>
